import React, { useEffect, useState } from 'react';
import Header from 'src/components/score-go/header/Header';
import HeaderStartup from 'src/components/demo-day/header/Header';
import { CompanyAPIService } from 'src/services/company.service';
import { openPopup } from 'src/store/common/common.slice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'src/store/hooks';
import { useGetIdentity } from 'src/hooks';
import { TGetCompany, TGetCompanyResponse, TGetProfileResponse } from 'src/services/apiEndpoint.types.ts';
import cx from './index.module.scss';
import anim from './htraction-go-loading.json';
import Lottie from "lottie-react";
import { supportchat, htractioncirlce } from 'src/assets/images';

interface GetGoUrlResponse {
  url: string;
}

const ScoreCard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const companyService = new CompanyAPIService();
  const [loading, setLoading] = useState(true);
  const [iframeUrl, setIframeUrl] = useState('');
  const [isSupportOpen, setIsSupportOpen] = useState(false);
  const { getIdentities } = useGetIdentity();
  const { authenticatedId } = getIdentities();
  const companyServiceRef = React.useRef(companyService);
  const { profile } = useAppSelector((state) => state.profile);
  const userRole = profile?.role;
  const userReferrerId = profile?.referrerInvestorId;
  console.log('User Role:', userRole);

  useEffect(() => {
    let mounted = true;
    const getGoUrl = async (companyId: string) => {
      interface GetGoUrlResponse {
        data: string;
      }

      if (!mounted) return '';

      const response = await companyServiceRef.current.getGoUrl<GetGoUrlResponse>({
        companyId
      });

      if (!mounted) return '';

      if (!response.status || !response.data.data) {
        throw new Error(response.message || 'Failed to get URL');
      }

      return response.data.data;
    };

    const fetchGoUrl = async () => {
      if (!mounted) return;
      try {
        // First, get user profile data
        const profileService = new (await import('src/services/profile.api.service')).ProfileAPIService();
        const userProfileResponse = await profileService.getProfile<TGetProfileResponse>({ id: authenticatedId });
        if (!mounted) return;
        if (!userProfileResponse.status || !userProfileResponse.data) {
          throw new Error(userProfileResponse.message || 'Failed to fetch user profile');
        }
        const userProfile = userProfileResponse.data.data;
        console.log("test hhf f", userProfile.referrerInvestorId)
        const refId = userProfile.referrerInvestorId;

        // Then, get company details
        const myCompanyResponse = await companyServiceRef.current.getCompany<TGetCompanyResponse>({
          id: authenticatedId
        });

        if (!mounted) return;

        if (!myCompanyResponse.status || !myCompanyResponse.data?.company) {
          throw new Error(myCompanyResponse.message || 'Failed to fetch company details');
        }

        const myCompany = myCompanyResponse.data.company;
        if (!myCompany?.id) {
          throw new Error('Company ID not found');
        }
        // ...existing code...
        // If goUserId doesn't exist, set it up first
        if (!myCompany?.goUserId) {
          const setGoResponse = await companyServiceRef.current.setStartupGo<{ message: string }>({
            companyId: myCompany.id,
            userId: authenticatedId
          });

          if (!mounted) return;

          if (!setGoResponse.status) {
            throw new Error(setGoResponse.message || 'Failed to set startup go');
          }
        }

        // // ---------
        if (refId !=null && refId?.startsWith("REF")) {
          console.log("refId executedjmskdnksj")
          const setGoResponse = await companyServiceRef.current.setStartupGo<{ message: string }>({
            companyId: myCompany.id,
            userId: authenticatedId
          });
          console.log("setgoResponse000000", setGoResponse)
          if (!mounted) return;

          if (!setGoResponse.status) {
            throw new Error(setGoResponse.message || 'Failed to set startup go');
          }
        }

        if (!mounted) return;

        // Get URL only once after setup (if needed) or directly
        const url = await getGoUrl(myCompany.id);
        if (mounted) {
          setIframeUrl(url);
        }
      } catch (error) {
        if (mounted) {
          console.error('Error fetching Go URL:', error);
          // dispatch(
          //   openPopup({
          //     popupMessage: error.message || 'Failed to load try again',
          //     popupType: 'error'
          //   })
          // );
          if (userRole === "Investor") {
          navigate('/score'); // Redirect back to scoring page on error 
          } else {
            navigate('/score'); // Redirect to startup page on error
          }
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    if (authenticatedId) {
      fetchGoUrl();
    }

    return () => {
      mounted = false;
    };
  }, [authenticatedId]);

  return (
    <div className={cx.demoDay}>
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.1); opacity: 0.7; }
            100% { transform: scale(1); opacity: 1; }
          }
          
          @keyframes rotate {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          @keyframes dash {
            0% { stroke-dashoffset: 100; }
            50% { stroke-dashoffset: 50; }
            100% { stroke-dashoffset: 0; }
          }
          .support-widget-backdrop {
            position: fixed;
            inset: 0;
            background: transparent; /* click-anywhere-to-close without dimming */
            z-index: 9999;
          }
          .support-widget-card {
            position: fixed;
            right: 24px;
            bottom: 92px; /* sits just above the FAB (60px + gap) */
            width: 380px;
            max-width: calc(100% - 48px);
            background: #ffffff;
            border-radius: 12px;
            box-shadow: 0 12px 40px rgba(0,0,0,0.25);
            padding: 24px 24px 28px;
          }
          .support-widget-card:after {
            content: '';
            position: absolute;
            right: 24px;
            bottom: -10px;
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid #ffffff; /* small arrow pointing to button */
            filter: drop-shadow(0 2px 2px rgba(0,0,0,0.1));
          }
          .support-close {
            position: absolute;
            right: 16px;
            top: 16px;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            background: #f2f2f2;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            color: #333;
          }
          .support-logo {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            background: #FF6A3A;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 16px;
          }
          .support-logo-mark {
            width: 28px;
            height: 28px;
            border-radius: 8px;
            background: #fff;
            color: #FF6A3A;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
          }
          .support-title {
            text-align: center;
            font-size: 20px;
            font-weight: 700;
            color: #222;
            margin-bottom: 6px;
          }
          .support-desc {
            text-align: center;
            font-size: 14px;
            color: #6b7280;
            line-height: 1.6;
            margin-bottom: 18px;
          }
          .support-cta {
            display: block;
            width: 100%;
            background: #FF6A3A;
            color: #fff;
            border: none;
            border-radius: 10px;
            padding: 12px 18px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
          }
          .support-fab {
            position: fixed;
            right: 24px;
            bottom: 24px;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background: #FF6A3A;
            box-shadow: 0 8px 24px rgba(0,0,0,0.25);
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9998;
          }
          .support-fab-icon {
            width: 28px;
            height: 28px;
            border-radius: 6px;
            background: #fff;
            color: #FF6A3A;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
          }
          .support-cta-link{
            text-decoration: none;}
        `}
      </style>
      {userRole !== "Investor" ? (<HeaderStartup />) : <Header />}
      <div>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center flex-column" style={{ height: '800px' }}>
            <div style={{
              position: 'relative',
              width: '200px',
              height: '200px',
              marginBottom: '20px'
            }}>
                <Lottie
                                        loop
                                        animationData={anim}
                                        autoplay 
                                    />
            </div>
            <div style={{
              color: '#000',
              fontSize: '30px',
              fontWeight: '500',
              textAlign: 'center',
              marginTop: '10px'
            }}>
              Loading your dashboard...
            </div>
            <div style={{
              color: '#666',
              fontSize: '14px',
              marginTop: '10px',
              textAlign: 'center'
            }}>
              We are loading your dashboard. This will take few minutes.
            </div>
          </div>
        ) : (
          <iframe
            src={iframeUrl}
            width="100%"
            title="Scoring Platform"
            loading="eager"
            style={{
              border: 'none',
              margin: '0px 0px',
              padding: '0px',
              marginTop: '89px',
              height: 'calc(100vh - 89px)', // Subtract header height
              display: 'block',
              position: 'relative'
            }}
          />
        )}
      </div>
      {/* Support Floating Action Button */}
      <button
        className="support-fab"
        aria-label="Open support"
        onClick={() => setIsSupportOpen(true)}
      >
        <img src={ supportchat } alt="Support Chat" style={{ width: '28px', height: '28px' }} />
      </button>

      {/* Support Modal Overlay */}
      {isSupportOpen && (
        <div
          className="support-widget-backdrop"
          role="dialog"
          aria-modal="true"
          onClick={() => setIsSupportOpen(false)}
        >
          <div
            className="support-widget-card"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="support-close" aria-label="Close" onClick={() => setIsSupportOpen(false)}>×</button>
            <div className="support-logo">
              <img src={ htractioncirlce } alt="Support Chat" style={{ width: '60px', height: '60px' }} />
            </div>
            <div className="support-title">Looking for support?</div>
            <div className="support-desc">
              Send us an email and we’ll follow up with exactly what you need.
            </div>
            <a
              href="mailto:hello@htraction.com"
              className="support-cta-link"
            >
              <button className="support-cta">Email Us</button>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScoreCard;
